module.exports = "/images/cover-sidebar-user.jpg?154f15e00072c113d023e4d251ea10ef";